import { createSlice } from '@reduxjs/toolkit';
import { isDefined } from 'common/utils';
import { isEqual, xorWith } from 'lodash-es';
import { ReportSource } from 'store/apis/insightsReport';

import { insightsReportsWizardActions } from './insightsReportsWizard.actions';

type InitialState = {
  selectedReportSource: ReportSource | undefined;
  selectedSimilarReportSourcesIds: number[];
  similarReportSources: ReportSource[];
  initialReportSource: Pick<ReportSource, 'id' | 'name'> | undefined;
};

export const insightsReportsWizardSliceInitialState: InitialState = {
  selectedReportSource: undefined,
  selectedSimilarReportSourcesIds: [],
  similarReportSources: [],
  initialReportSource: undefined,
};

export const insightsReportsWizardSlice = createSlice({
  name: 'insightsReportsWizard',
  initialState: insightsReportsWizardSliceInitialState,
  reducers: {
    resetInsightsReportsWizardState: () => insightsReportsWizardSliceInitialState,
  },
  extraReducers: (builder) =>
    builder
      .addCase(insightsReportsWizardActions.reportSources.reportSourceSelected, (state, { payload }) => {
        state.selectedReportSource = payload;
      })
      .addCase(
        insightsReportsWizardActions.similarReportSources.selectAllCheckboxToggled,
        (state, { payload: { isChecked } }) => {
          if (!isChecked) {
            state.selectedSimilarReportSourcesIds = [];
          } else {
            state.selectedSimilarReportSourcesIds = state.similarReportSources.map((source) => source.id);
          }
        }
      )
      .addCase(insightsReportsWizardActions.similarReportSources.reportSourceSelected, (state, { payload }) => {
        const updatedSimilarSources = xorWith(state.selectedSimilarReportSourcesIds, [payload.id], isEqual);
        state.selectedSimilarReportSourcesIds = updatedSimilarSources;
      })
      .addCase(insightsReportsWizardActions.similarReportSources.similarReportSourcesFetched, (state, { payload }) => {
        state.similarReportSources = [state.selectedReportSource, ...payload].filter(isDefined);
        state.selectedSimilarReportSourcesIds = state.similarReportSources.map((source) => source.id);
      })
      .addCase(insightsReportsWizardActions.similarReportSources.similarReportSourcesClosed, (state) => {
        state.similarReportSources = [];
        state.selectedSimilarReportSourcesIds = [];
        state.initialReportSource = undefined;
      })
      .addCase(insightsReportsWizardActions.reportSources.setInitialReportSource, (state, { payload }) => {
        state.initialReportSource = payload;
      }),
});
